export default __webpack_public_path__ + "static/media/Nav-Reminders.897424f9.svg";